import React, { useState } from 'react';

import { ConnectionStatus } from '../../hooks/fitness/useFitnessConnection';
import { StravaSettingsModal } from './StravaSettingsModal/StravaSettingsModal';
import { StravaStopSharingConfirmation } from './StravaStopSharingConfirmation/StravaStopSharingConfirmation';

interface StravaModalProps {
  connectionStatus?: ConnectionStatus;
  onClose: () => void;
}

export type ModalType = 'settings' | 'confirmation';

export const StravaModal = React.forwardRef(
  (
    { onClose, connectionStatus }: StravaModalProps,
    ref?: React.Ref<HTMLDivElement>,
  ) => {
    const [modalType, setModalType] = useState<ModalType>('settings');

    if (modalType === 'settings') {
      return (
        <StravaSettingsModal
          connectionStatus={connectionStatus}
          onClose={onClose}
          ref={ref}
          onModalTypeChange={setModalType}
        />
      );
    }
    if (modalType === 'confirmation') {
      return (
        <StravaStopSharingConfirmation
          onClose={onClose}
          onModalTypeChange={setModalType}
          ref={ref}
        />
      );
    }
    return null;
  },
);

StravaModal.displayName = 'StravaModal';
